var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4139",
    "data-name": "Group 4139",
    transform: "translate(-369.75 -244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6720",
    "data-name": "Rectangle 6720",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(369.75 244)",
    fill: "#c2fae5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-complete-3202980_1_",
    "data-name": "noun-complete-3202980 (1)",
    transform: "translate(133.615 18.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32566",
    "data-name": "Path 32566",
    d: "M249.343,241.551l-2.689-2.689a1.709,1.709,0,0,0-2.416,2.416l3.9,3.9a1.693,1.693,0,0,0,2.416,0l7.483-7.483a1.709,1.709,0,0,0-2.416-2.416Z",
    stroke: "#c2fae5",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8f60ed6f5bbb49b7932ea1e1241c1631.svg";
export { ForwardRef as ReactComponent };